<template>
  <div class="flex_vh100 home">
    <div>
      <!-- 顶部导航 -->
      <van-nav-bar
        title="推广员返点和结算"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      >
        <template #right>
          <van-icon
            name="filter-o"
            size="20"
            @click="showFilter = !showFilter"
          />
        </template>
      </van-nav-bar>
    </div>
    <div class="flex_vh100">
      <UniversalSearch
        v-show="showFilter"
        ref="universalSearch"
        title="筛选"
        :initial-form-data="formData"
        @search="handleSearch"
        @reset="handleReset"
      >
        <!-- 自定义搜索内容插槽 -->
        <template #search-content="{ formData, handleSearch }">
          <div class="search-fields">
            <div class="search-row">
              <div class="search-type">
                <van-dropdown-menu>
                  <van-dropdown-item
                    v-model="formData.searchType"
                    :options="searchTypeOptions"
                    placeholder="选择类型"
                  />
                </van-dropdown-menu>
              </div>
              <div class="search-input">
                <van-field
                  v-model="formData.searchName"
                  placeholder="请输入搜索关键词"
                  clearable
                  :autofocus="false"
                  @keyup.enter="handleSearch"
                  :disabled="formData.searchType == 0"
                >
                  <template #right-icon>
                    <van-icon name="search" @click="handleSearch" />
                  </template>
                </van-field>
              </div>
            </div>
          </div>
        </template>
      </UniversalSearch>

      <!-- 列表 -->
      <ListPage
        ref="listPage"
        :request-api="_getRebateList"
        :params="searchInfo"
        class="flex_vh100"
      >
        <template #default="{ list }">
          <div class="product-grid">
            <div v-for="item in list" :key="item.id" class="product-item">
              <van-cell-group>
                <van-cell>
                  <!-- 使用 default 插槽完全自定义 -->
                  <template #default>
                    <div class="custom-cell">
                      <!-- 左侧区域 -->
                      <div class="cell-left">
                        <div class="cell-title">返点账户</div>
                      </div>
                      <!-- 右侧区域 -->
                      <div class="cell-value">
                        <div class="accountStyle">
                          <div v-if="item.agentId">
                            {{ item.agentId }}({{ item.agent_number }})
                          </div>
                          <div v-if="item.agent_mobile">
                            手机号:{{ item.agent_mobile }}
                          </div>
                          <div v-if="item.agent_nickname">
                            昵称:{{ item.agent_nickname }}
                          </div>
                          <div v-if="item.agent_wechat_nickname">
                            微信:{{ item.agent_wechat_nickname }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </van-cell>
                <van-cell>
                  <!-- 使用 default 插槽完全自定义 -->
                  <template #default>
                    <div class="custom-cell">
                      <!-- 左侧区域 -->
                      <div class="cell-left">
                        <div class="cell-title">支付账户</div>
                      </div>
                      <!-- 右侧区域 -->
                      <div class="cell-value">
                        <div class="accountStyle">
                          <div v-if="item.from_id">
                            {{ item.from_id }}({{ item.from_id_number }})
                          </div>
                          <div v-if="item.from_id_mobile">
                            手机号:{{ item.from_id_mobile }}
                          </div>
                          <div v-if="item.from_id_nickname">
                            昵称:{{ item.from_id_nickname }}
                          </div>
                          <div v-if="item.from_id_wechat_nickname">
                            微信:{{ item.from_id_wechat_nickname }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </van-cell>
                <van-cell
                  title="返点ID / 返点类型"
                  :value="
                    item.ar_id +
                    ' / ' +
                    item.commodityName +
                    '(' +
                    item.useToStr +
                    ')'
                  "
                ></van-cell>
                <van-cell
                  title="净营收 / 实际支付"
                  :value="
                    '￥' +
                    (
                      (item.realPays -
                        item.realPays * (item.feeRate / 100000)) /
                      100.0
                    ).toFixed(2) +
                    ' / ' +
                    '￥' +
                    (item.realPays / 100.0).toFixed(2)
                  "
                ></van-cell>
                <van-cell
                  title="返点金额 / 返点比例"
                  :value="
                    '￥' +
                    (item.rebateAmount / 100.0).toFixed(2) +
                    ' / ' +
                    item.rebates / 100.0 +
                    '%'
                  "
                ></van-cell>
                <van-cell title="创建时间" :value="item.createTime"></van-cell>
              </van-cell-group>
            </div>
          </div>
        </template>
      </ListPage>
    </div>
  </div>
</template>

<script>
import ListPage from "./controls/ListPage.vue";
import UniversalSearch from "./controls/UniversalSearch.vue";
import { GetRebateList } from "../api/financeapi.js";
export default {
  name: "AgentRebaterecord",
  components: { ListPage, UniversalSearch },
  data() {
    const now = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(now.getFullYear() - 1);
    return {
      showFilter: false,
      isCollapsed: false, // 搜索区域是否收缩
      formData: {
        searchType: 0,
        searchName: "",
      },
      searchInfo: {
        searchType: 0,
        searchName: "",
      },

      searchTypeOptions: [
        { value: 0, text: "全部" },
        { value: 1, text: "手机号" },
        { value: 2, text: "账户number" },
        { value: 3, text: "微信昵称" },
        { value: 4, text: "微信ID" },
        { value: 5, text: "个人昵称" },
        { value: 6, text: "推荐码" },
        { value: 7, text: "推荐人number" },
      ],
    };
  },
  watch: {
    showFilter(val) {
      if (this.$refs.universalSearch) {
        val
          ? this.$refs.universalSearch.expand()
          : this.$refs.universalSearch.collapse();
      }
    },
    $route(to) {
      // 路由变化时更新激活的标签
      if (to.name == "AgentRebaterecord") {
      }
    },
  },
  computed: {},
  methods: {
    goBack() {
      this.$router.go(-1); // 后退一步
    },
    // 执行搜索
    handleSearch(searchParams) {
      console.log(searchParams);
      this.searchInfo = searchParams;
    },

    // 重置搜索条件
    handleReset() {
      this.formData = {
        searchType: 0,
        searchName: "",
      };
    },

    //查询返点列表
    _getRebateList(params) {
      return GetRebateList(params);
    },
  },
  mounted() {},
};
</script>

<style scoped>
/* 隐藏 UniversalSearch 自带的 header，切换按钮已在导航栏 */
:deep(.collapsible-search .search-header) {
  display: none;
}

/* 搜索区域 */
.search-fields {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.search-row {
  display: flex;
  gap: 10px;
}

.search-row[style*="column"] {
  flex-direction: column;
}

.search-type {
  flex-shrink: 0;
  width: 110px;
}

.search-type :deep(.van-dropdown-menu__bar) {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: none;
  height: 36px;
  border: 1px solid #ebedf0;
}

.search-type :deep(.van-dropdown-menu__title) {
  padding: 0 10px;
  line-height: 34px;
  font-size: 13px;
}

.search-input {
  flex: 1;
}

.search-input :deep(.van-field) {
  background-color: #fff;
  border-radius: 6px;
  padding: 6px 10px;
  border: 1px solid #ebedf0;
}

.search-input :deep(.van-field__control) {
  font-size: 13px;
}

.search-input :deep(.van-field__right-icon),
.search-input :deep(.van-field__left-icon) {
  color: #1989fa;
  cursor: pointer;
}

.product-item {
  background-color: #fff;
  border-bottom: 1px solid #f5f6f8;
  margin-bottom: 10px;
}

.product-item :deep(.van-cell-group) {
  background-color: transparent;
}

.product-item :deep(.van-cell-group::after) {
  display: none;
}

.product-item :deep(.van-cell) {
  padding: 10px 14px;
  font-size: 13px;
  line-height: 1.5;
}

.product-item :deep(.van-cell::after) {
  display: none;
}

.product-item :deep(.van-cell__title) {
  color: #323233;
  font-size: 13px;
}

.product-item :deep(.van-cell__value) {
  color: #969799;
  font-size: 13px;
}

.cloth-icon {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  object-fit: cover;
  margin-right: 6px;
}
.custom-cell {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.cell-title {
  font-size: 13px;
  color: #323233;
}

.cell-label {
  font-size: 11px;
  color: #969799;
}

.cell-value {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #969799;
  font-size: 13px;
}

.cell-left {
  flex: 1;
}

.accountStyle {
  text-align: right;
}
</style>